import { render, staticRenderFns } from "./dialA22.vue?vue&type=template&id=52f22bf9&"
import script from "./dialA22.vue?vue&type=script&lang=js&"
export * from "./dialA22.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "dialA22.vue"
export default component.exports